<template>
  <div class="formulario-solicitud-princ" data-app>
    <div class="div-titulo-seccion">
      <div class="row row-cols-lg-12">
        <div class="col-lg-8 columna-titulo">
          <p class="titulo-seccion-t">
            {{this.NombreCompletoProspecto}}
          </p>
        </div>
        <div class="col-lg-4 columna-boton">
          <label
            class="label-guardar-progreso-t"
            @click.prevent="GuardarBorradorSolicitud()"
            v-if="seccionActual != 5 && soloLectura == false"
            >Guardar progreso</label
          >
        </div>
      </div>
    </div>
    <div class="container form-container">
      <stepper-movil
        :pasos="this.pasos"
        :pasoActual="this.seccionActual"
      ></stepper-movil>
      <stepper :pasos="this.pasos" :pasoActual="this.seccionActual"></stepper>
      <div ref="seccion-1" v-show="seccionActual == 1">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioUno"
          v-bind:class="{ 'was-validated': formularioValidado1 }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Datos generales</strong>
            <p class="parrafo-instrucciones mt-2">
              Ingresa tus datos en los campos correctamente,
              recuerda que puedes dar clic sobre el icono de ayuda
              <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
              para conocer más detalles sobre cada campo.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿Qué servicio deseas adquirir?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona ¿Qué servicio deseas? * "
                :arreglo="this.catalogos.servicios"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.servicio"
                :requerido="true"
                invalidFeedback="Debes de seleccionar un servicio."
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿Qué tipo de inmueble?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona el producto *"
                :arreglo="this.catalogos.productos"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.producto"
                invalidFeedback="Debes de seleccionar un producto."
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Nombre(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                maxlength="100"
                type="text"
                placeholder="Nombre(s) *"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.nombres"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Apellido paterno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                maxlength="100"
                type="text"
                placeholder="Apellido Paterno *"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.apellidoPaterno"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Apellido materno"
              :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                maxlength="100"
                placeholder="Apellido Materno "
                type="text"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.apellidoMaterno"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo
                texto="Fecha de nacimiento"
                :requerido="true"
              ></etiqueta-campo>
              <input-fecha
                :deshabilitado="soloLectura"
                idioma="es-MX"
                v-model="DatosSolicitudGeneral.fechaNacimiento"
                :fechaMaxima="new Date().toISOString()"
                required
              ></input-fecha>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La fecha de nacimiento es requerida.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12" style="align-items: center">
            <div class="col-lg-6 col-sm-6 columna--campos">
              <etiqueta-campo texto="RFC" :requerido="true"></etiqueta-campo>
              <span style="display: flex; align-items: center">
                <input
                  maxlength="13"
                  :disabled="this.soloLectura"
                  type="text"
                  placeholder="RFC *"
                  class="form-control campo-basico"
                  v-model="DatosPersonaFisica.rfc"
                  required
                />
                <div
                  class="invalid-feedback"
                  style="
                    text-align: left;
                    margin-left: 10px;
                    font-family: 'Poppins';
                  "
                >
                  El RFC es obligatorio.
                </div>
                <span
                  v-tooltip.right="
                    'Para facturar es indispensable ingresar tu RFC con homoclave, de lo contrario no es necesario complementarlo'
                  "
                >
                  <i
                    class="fas fa-question-circle icono-ayuda fa-lg"
                    style="padding-left: 20px"
                  ></i>
                </span>
              </span>
            </div>
            <div class="col-lg-6 columna--campos">
              <div class="row">
                <div class="col-3">
                  <etiqueta-campo
                    texto="Género"
                    :requerido="true"
                  ></etiqueta-campo>
                </div>
                <div class="col">
                  <div
                    class="form-check form-check-inline"
                    v-for="(sexo, index) in catalogos.sexos"
                    v-bind:key="sexo.value"
                  >
                    <input
                      :disabled="soloLectura"
                      required
                      class="form-check-input"
                      v-model="DatosPersonaFisica.sexo"
                      type="radio"
                      name="inlineRadioOptions"
                      :id="'sexoOpcion' + index"
                      :value="sexo.value"
                    />
                    <label
                      class="etiqueta-checkbox"
                      :for="'sexoOpcion' + index"
                    >
                      {{ sexo.text.substring(0, 1) }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo texto="Nacionalidad"></etiqueta-campo>
              <input
                disabled
                type="text"
                class="form-control campo-basico"
                value="MEXICANA"
              />
            </div>
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo texto="Lugar de nacimiento"></etiqueta-campo>
              <input
                disabled
                type="text"
                class="form-control campo-basico"
                value="MEXICO"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Tipo de identificación"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Tipo de identificación *"
                :arreglo="this.catalogos.tiposIdentificacion"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.tipoIdentificacion"
                invalidFeedback="Debes seleccionar el tipo de identifiación que usas."
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Número de identificación"
                :requerido="true"
              ></etiqueta-campo>
              <span style="display: flex; align-items: center">
                <input
                  maxlength="30"
                  :disabled="this.soloLectura"
                  placeholder="Número de identificación "
                  type="text"
                  class="form-control campo-basico"
                  required
                  v-model="DatosPersonaFisica.numeroIdentificacion"
                />
                <div
                  class="invalid-feedback"
                  style="
                    text-align: left;
                    font-family: 'Poppins';
                    padding-left: 10px;
                  "
                >
                  Debes ingresar tu número de identitifación.
                </div>
                <span
                  v-tooltip.right="
                    'Puedes encontrar tu número de identificación al reverso de tu INE.'
                  "
                >
                  <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
                </span>
              </span>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo texto="CURP" :requerido="true"></etiqueta-campo>
              <input
                maxlength="18"
                :disabled="this.soloLectura"
                type="text"
                placeholder="CURP *"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.curp"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La CURP es obligatoria.
              </div>
              <label class="form-label label-curp"
                >¿No conoces tu CURP?
                <a
                  href="https://www.gob.mx/curp/"
                  target="_blank"
                  class="a-curp"
                  >Consúltala aquí</a
                ></label
              >
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Estado civil"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Estado civil * "
                :arreglo="this.catalogos.estadosCiviles"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.estadoCivil"
                invalidFeedback="Debes seleccionar tu estado civil actual."
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <!--Regimen Matrimonial-->
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              hidden
              v-if="DatosPersonaFisica.estadoCivil != 1"
            >
              <etiqueta-campo
                texto="Regimen matrimonial"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                placeholder="Régimen matrimonial *"
                :arreglo="this.catalogos.regimenesMatrimoniales"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.regimenMatrimonial"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Regimen matrimonial"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Régimen matrimonial *"
                :arreglo="this.catalogos.regimenesMatrimoniales"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.regimenMatrimonial"
                invalidFeedback="Debes elegir tu regimen matrimonial actual."
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div
            v-if="DatosPersonaFisica.estadoCivil == 1"
            class="row row-cols-lg-12">
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Nombre Completo del conyuge"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  maxlength="100"
                  type="text"
                  placeholder="Nombre Completo del conyuge *"
                  class="form-control campo-basico"
                  v-model="DatosPersonaFisica.nombreConyuge"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Teléfono fijo conyuge"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  placeholder="Teléfono fijo conyuge (10 dígitos)"
                  :disabled="this.soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                  min="0"
                  class="form-control campo-basico"
                  v-model="PuntoContactoConyuge.telefonoFijoConyuge.valor"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Teléfono móvil conyuge"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="this.soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                  min="0"
                  placeholder="Teléfono móvil conyuge (10 dígitos) *"
                  class="form-control campo-basico"
                  v-model="PuntoContactoConyuge.telefonoMovilConyuge.valor"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Correo electrónico conyuge"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="this.soloLectura"
                  type="email"
                  placeholder="Correo electrónico conyuge (ej. nombre@mail.com) *"
                  class="form-control campo-basico campo-minuscula"
                  v-model="PuntoContactoConyuge.correoConyuge.valor"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-md-6 col-lg-12 columna--campos">
              <etiqueta-campo
                texto="Regimen Fiscal"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Regimen Fiscal"
                :arreglo="this.catalogos.regimenesFiscales"
                llave="regimenFiscalId"
                valor="regimenFiscalId"
                texto="nombreRegimen"
                v-model="DatosPersonaFisica.regimenFiscalId"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El regimen fiscal es requerido.
              </div>
            </div>
          </div>

          <div class="col-12 mt-3">
            <button
              ref="submitUno"
              @click.prevent="ValidaFormSiguiente"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
      </div>
      <div ref="seccion-2" v-show="seccionActual == 2">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioDos"
          v-bind:class="{ 'was-validated': formularioValidado2 }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Domicilio</strong>
            <p class="parrafo-instrucciones mt-2">
              Ingresa correctamente los datos de tu domicilio actual.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-5 columna--campos">
              <etiqueta-campo texto="Calle" :requerido="true"></etiqueta-campo>
              <input
                maxlength="255"
                :disabled="this.soloLectura"
                placeholder="Calle * "
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralParticular.calle"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La calle es requerida.
              </div>
            </div>
            <div class="col-lg-3 columna--campos">
              <etiqueta-campo texto="Número" :requerido="true"></etiqueta-campo>
              <input
                maxlength="20"
                :disabled="this.soloLectura"
                placeholder="Número *"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralParticular.numero"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El número es requerido.
              </div>
            </div>
            <div class="col-lg-4 columna--campos">
              <etiqueta-campo
                texto="Código postal"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                placeholder="Código Postal * "
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                required
                min="0"
                class="form-control campo-basico"
                v-model="codigoPostalParticular"
                pattern="[0-9]{5}"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El código postal es requerido.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Estado" :requerido="true"></etiqueta-campo>
              <input
                placeholder="Estado *"
                type="text"
                class="form-control campo-basico"
                v-model="direccion.estado"
                disabled
                required
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Delegación o municipio"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Delegación o municipio *"
                type="text"
                class="form-control campo-basico"
                v-model="direccion.ciudad"
                disabled
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              v-if="
                (codigoPostalValido == true && catalogos.colonias.length > 0) ||
                  coloniaExistenteParticular != null
              "
            >
              <etiqueta-campo
                texto="Colonia"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona una colonia *"
                :arreglo="this.catalogos.colonias"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="DatosUbicacionParticular.coloniaId"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La colonia es requerida.
              </div>
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Colonia"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                disabled
                placeholder="Selecciona una colonia *"
                :arreglo="this.catalogos.colonias"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="DatosUbicacionParticular.coloniaId"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Teléfono fijo"
              :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Teléfono fijo (10 dígitos)"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijo.valor"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12" style="align-items: center">
            <div
              class="col-lg-6 columna--campos"
              v-if="PuntoContactoGeneral.telefonoMovil.valor != null"
            >
              <etiqueta-campo
                texto="Teléfono móvil"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                placeholder="Teléfono móvil (10 dígitos) *"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Teléfono móvil"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                placeholder="Teléfono móvil (10 dígitos) *"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
            <div
              class="col-lg-6 columna--campos"
              v-if="PuntoContactoGeneral.correo1.valor != null"
            >
              <etiqueta-campo
                texto="Correo electrónico"
                :requerido="true"
              ></etiqueta-campo>
              <span style="display: flex; align-items: center">
                <input
                  disabled
                  type="email"
                  placeholder="Correo electrónico (ej. nombre@mail.com) *"
                  class="form-control campo-basico campo-minuscula"
                  v-model="PuntoContactoGeneral.correo1.valor"
                  required
                />
                <span
                  v-tooltip.right="
                    'Si necesitas actualizar o modificar tus datos contacta a tu embajador, el podrá apoyarte en este proceso.'
                  "
                >
                  <i
                    class="fas fa-question-circle icono-ayuda fa-lg"
                    style="padding-left: 20px"
                  ></i>
                </span>
              </span>
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Correo electrónico"
                :requerido="true"
              ></etiqueta-campo>
              <span style="display: flex; align-items: center">
                <input
                  type="email"
                  placeholder="Correo electrónico (ej. nombre@mail.com) *"
                  class="form-control campo-basico campo-minuscula"
                  v-model="PuntoContactoGeneral.correo1.valor"
                  required
                />
                <span
                  v-tooltip.right="
                    'Si necesitas actualizar o modificar tus datos contacta a tu embajador, el podrá apoyarte en este proceso.'
                  "
                >
                  <i
                    class="fas fa-question-circle icono-ayuda fa-lg"
                    style="padding-left: 20px"
                  ></i>
                </span>
              </span>
            </div>
          </div>
          <div class="col-12">
            <button
              ref="submitDos"
              @click.prevent="ValidaFormSiguiente"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
      </div>
      <div ref="seccion-3" v-show="seccionActual == 3">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioTres"
          v-bind:class="{ 'was-validated': formularioValidado3 }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Ingresos</strong>
            <p class="parrafo-instrucciones mt-2">
              Ingresa correctamente los datos sobre tus ingresos.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona tu profesión"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                invalidFeedback="Debes seleccionar tu profesión."
                placeholder="Selecciona tu profesión *"
                :arreglo="this.catalogos.profesiones"
                llave="profesionId"
                valor="profesionId"
                texto="descripcion"
                v-model="DatosPersonaFisica.profesion"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona tu grado de estudios"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                placeholder="Selecciona tu grado de estudios *"
                invalidFeedback="Debes seleccionar tu grado de estudios."
                :arreglo="this.catalogos.gradosEstudio"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.gradoEstudios"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿Cuántas personas dependen de ti?"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                placeholder="Número de dependientes"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                max="10"
                maxlength="2"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.numeroDependientes"
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona la divisa de tus ingresos"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                invalidFeedback="La divisa es requerida."
                placeholder="Selecciona la divisa de tu ingreso/egreso. *"
                :arreglo="this.catalogos.divisas"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosIngreso.divisa"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿A cuánto asciende tu ingreso mensual?"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                :disabled="this.soloLectura"
                class="form-control campo-basico"
                :options="opcionesAutoNumeric"
                :placeholder="'Ingreso Mensual (Ej. $ 12,000.00)*'"
                v-model="DatosIngreso.monto"
                required
              ></VueAutonumeric>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes escribir el monto de tu ingreso mensual.
              </div>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿A cuánto asciende tu egreso mensual?"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                :disabled="this.soloLectura"
                class="form-control campo-basico"
                :options="opcionesAutoNumeric"
                :placeholder="'Egreso Mensual (Ej. $ 8,000.00)*'"
                v-model="DatosPersonaFisica.egresoMensual"
                required
              ></VueAutonumeric>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes escribir el monto de tu egreso mensual.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona tu tipo de vivienda actual"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                invalidFeedback="Debes seleccionar tu tipo de vivienda actual."
                placeholder="Selecciona tu tipo de vivienda actual. *"
                :arreglo="this.catalogos.tiposVivienda"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.tipoVivienda"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona tu actividad comercial"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona tu actividad comercial *"
                invalidFeedback="Debes seleccionar tu actividad comercial."
                :arreglo="this.catalogos.tiposEmpleo"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.tipoEmpleo"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Selecciona el tipo de ingreso que percibes"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona el tipo de ingreso que percibes *"
                invalidFeedback="Debes seleccionar el tipo de ingreso que percibes"
                :arreglo="this.catalogos.tiposIngreso"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosIngreso.tipoIngreso"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Nombre de la empresa para la que trabajas"
              ></etiqueta-campo>
              <input
                placeholder="Nombre de la empresa"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosIngreso.empresa"
              />
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Cargo actual que ejerces"></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Cargo actual"
                :arreglo="this.catalogos.puestos"
                llave="puestoId"
                valor="puestoId"
                texto="puesto"
                v-model="DatosIngreso.puestoId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿Cuántos años llevas trabajando para la empresa?"
              ></etiqueta-campo>
              <input
                placeholder="Antigüedad (años)"
                invalidFeedback="La antigüedad en años es requerida."
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                max="65"
                maxlength="2"
                class="form-control campo-basico"
                v-model="DatosIngreso.antiguedadAnios"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes escribir los años que llevas laborando.
              </div>
            </div>
          </div>

          <!-- <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              hidden
              v-if="DatosIngreso.puestoId != 19"
            >
              <etiqueta-campo
                texto="Puesto"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Cargo actual"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosIngreso.otroPuesto"
              />             
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Puesto"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Cargo actual"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosIngreso.otroPuesto"
              />             
            </div>
          </div> -->

          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿En qué area o departamento de la empresa trabajas?"
              ></etiqueta-campo>
              <input
                maxlength="64"
                placeholder="Departamento"
                :disabled="this.soloLectura"
                type="texto"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.departamentoEmpleo"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="¿Cuál es el giro de la empresa para la que trabajas?"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Giro de la empresa"
                :arreglo="this.catalogos.giros"
                llave="giroId"
                valor="giroId"
                texto="giro"
                v-model="DatosIngreso.giroEmpresaId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (calle)"
              ></etiqueta-campo>
              <input
                placeholder="Domicilio de la empresa (calle)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralOficina.calle"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (número)"
              ></etiqueta-campo>
              <input
                maxlength="20"
                placeholder="Domicilio de la empresa (número)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralOficina.numero"
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (Código postal)"
              ></etiqueta-campo>
              <input
                placeholder="Ej. 56634"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                class="form-control campo-basico"
                v-model="codigoPostalOficina"
                pattern="[0-9]{5}"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (Estado)"
              ></etiqueta-campo>
              <input
                placeholder="Estado"
                type="text"
                class="form-control campo-basico"
                v-model="direccionEmpresa.estado"
                disabled
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Domicilio de la empresa (Delegación o municipio)"
              ></etiqueta-campo>
              <input
                placeholder="Delegación o municipio"
                type="text"
                class="form-control campo-basico"
                v-model="direccionEmpresa.ciudad"
                disabled
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              v-if="
                (codigoPostalValidoEmpresa == true &&
                  catalogos.coloniasEmpresa.length > 0) ||
                  coloniaExistenteOficina != null
              "
            >
              <etiqueta-campo
                texto="Domicilio de la empresa (Colonia)"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona una colonia *"
                :arreglo="this.catalogos.coloniasEmpresa"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="DatosUbicacionOficina.coloniaId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Domicilio de la empresa (Colonia)"
              ></etiqueta-campo>
              <DropDown
                disabled
                placeholder="Selecciona una colonia *"
                :arreglo="this.catalogos.coloniasEmpresa"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="DatosUbicacionOficina.coloniaId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Teléfono de oficina"></etiqueta-campo>
              <input
                placeholder="Teléfono de oficina (10 dígitos)"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijoOficina.valor"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Correo electrónico de oficina"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="email"
                placeholder="Ej. luis@empresa.com"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correo2.valor"
              />
            </div>
          </div>
          <div class="col-12">
            <button
              ref="submitTres"
              @click.prevent="ValidaFormSiguiente"
              class="btn btn-primary"
              hidden
              type="submit"
            ></button>
          </div>
        </form>
      </div>
      <div ref="seccion-4" v-show="seccionActual == 4">
        <div class="row row-cols-lg-12 w-100 mt-3">
          <strong class="titulo-seccion">Beneficiarios</strong>
          <p class="parrafo-instrucciones mt-2">
            Ingresa correctamente los datos de tu(s) beneficiarios.
          </p>
        </div>
        <div
          v-for="(formBeneficiario, index) in FormBeneficiarios"
          v-bind:key="index"
        >
          <form class="mt-3" novalidate>
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Nombre(s)"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Nombres(s) *"
                  class="form-control campo-basico"
                  v-model="formBeneficiario.nombre"
                  required
                />
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Apellido paterno"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Apellido paterno *"
                  v-model="formBeneficiario.apellidoPaterno"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo texto="Apellido materno"
                :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Apellido materno"
                  v-model="formBeneficiario.apellidoMaterno"
                  class="form-control campo-basico"
                  required
                />
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Parentesco o relación"
                  :requerido="true"
                ></etiqueta-campo>
                <DropDown
                  :disabled="soloLectura"
                  placeholder="Selecciona el tipo de relación *"
                  :arreglo="catalogos.parentescos"
                  llave="value"
                  valor="value"
                  texto="text"
                  v-model="formBeneficiario.parentesco"
                  :requerido="true"
                ></DropDown>
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Porcentaje"
                  :requerido="true"
                ></etiqueta-campo>
                <div class="input-group">
                  <input
                    :disabled="soloLectura"
                    @keyup="LimitarPorcentaje(index)"
                    type="number"
                    onkeydown="return event.keyCode !== 69"
                    onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                    min="0"
                    class="form-control campo-basico"
                    v-model="formBeneficiario.porcentaje"
                    placeholder="Porcentaje *"
                    required
                  />
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="
                        border-radius: 0px;
                        border: 1px solid;
                        font-family: 'Poppins';
                      "
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Teléfono móvil"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                  min="0"
                  placeholder="Teléfono móvil (10 dígitos)*"
                  v-model="formBeneficiario.telefono"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div
              class="col-lg-12 col-sm-12"
              style="text-align: end"
              v-if="soloLectura == false"
            >
              <strong
                v-if="FormBeneficiarios.length > 1"
                class="etiqueta-nuevo-documento"
                @click.prevent="EliminarBeneficiarioTest(index)"
                >Eliminar beneficiario</strong
              >
            </div>
          </form>
        </div>
        <div
          class="col-lg-12 col-sm-12 col-agregar-beneficiario"
          style="text-align: end"
        >
          <label
            v-if="this.soloLectura == false"
            class="etiqueta-nuevo-documento"
            @click.prevent="AgregarFormBeneficiario(false)"
            >Agregar otro beneficiario</label
          >
        </div>
      </div>
      <div ref="seccion-5" v-show="seccionActual == 5">

        <div class="row row-cols-lg-12 w-100 mt-3">
          <strong class="titulo-seccion"
            >Referencias personales (Opcional)</strong
          >

      
            <!--<div class="col-4 campo-pago" style="text-align: initial">
               <label class="parrafo-instrucciones"
                >Agregar Referencias?</label
              >
            </div>
            <div class="col-8">
              <span
                class="opcion-checkbox"
                v-for="opcion in catalogos.referencias"
                v-bind:key="opcion.value"
              >
                <input
                  type="radio"
                  class="form-check-input"
                  :value="opcion.value"
                  v-model="tieneReferencias"
                  required
                />
                <label class="etiqueta-checkbox">
                  {{ opcion.text }}
                </label>
              </span>
            </div>-->
       

          <p class="parrafo-instrucciones mt-2">
            Ingresa correctamente los datos de tu(s) referencias personales.
          </p>
        </div>

      <!--<div v-if="tieneReferencias">-->
        
        <div
          v-for="(formReferencia, index) in FormReferencias"
          v-bind:key="index"
          class="mb-3"
        >
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Nombre(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="text"
                placeholder="Nombres(s) *"
                class="form-control campo-basico campo-item-anadido"
                v-model="formReferencia.nombre"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Apellido paterno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="text"
                placeholder="Apellido paterno *"
                v-model="formReferencia.apellidoPaterno"
                class="form-control campo-basico campo-item-anadido"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Apellido materno"></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="text"
                placeholder="Apellido materno"
                v-model="formReferencia.apellidoMaterno"
                class="form-control campo-basico campo-item-anadido"
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Parentesco o relación"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="soloLectura"
                placeholder="Selecciona el tipo de relación *"
                :arreglo="catalogos.parentescos"
                llave="value"
                valor="value"
                texto="text"
                v-model="formReferencia.relacion"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Años de conocerse"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                placeholder="Años de conocerse *"
                class="form-control campo-basico campo-item-anadido"
                maxlength="2"
                v-model="formReferencia.aniosRelacion"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Correo electrónico"></etiqueta-campo>
              <input
                @change="ValidarCorreoReferencia(index)"
                :disabled="soloLectura"
                type="email"
                placeholder="Correo electrónico"
                class="
                  form-control
                  campo-basico campo-item-anadido campo-minuscula
                "
                v-model="formReferencia.correo"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Teléfono fijo"></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                placeholder="Teléfono fijo (10 Dígitos)"
                class="form-control campo-basico campo-item-anadido"
                maxlength="10"
                v-model="formReferencia.telefonoParticular"
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Teléfono móvil"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                placeholder="Teléfono móvil (10 Dígitos) *"
                class="form-control campo-basico campo-item-anadido"
                v-model="formReferencia.telefonoMovil"
                maxlength="10"
                required
              />
            </div>
          </div>
          <div
            class="col-lg-12 col-sm-12"
            style="text-align: end"
            v-if="soloLectura == false"
          >
          
            <strong
              v-if="
                FormReferencias.length > 1 && index >= 0
              "
              class="etiqueta-nuevo-documento"
              @click.prevent="EliminarReferenciaTest(index)"
              >Eliminar referencia</strong
            >
          </div>
        </div>
        <!--</div>-->
        <div class="col-lg-12 col-sm-12" style="text-align: end">
          <label
            v-if="this.soloLectura == false && FormReferencias.length < 2"
            class="etiqueta-nuevo-documento"
            @click.prevent="AgregarFormReferencia(false)"
            >Agregar otra referencia</label
          >
        </div>
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioUltimo"
          v-bind:class="{ 'was-validated': formularioUltimoValidado }"
        >
          <div class="row row-cols-lg-12 w-100 mt-4">
            <p class="parrafo-instrucciones mt-2">
              En caso de la autorización del Financiamiento acepto cubrir la
              cuota de inscripción con:
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo
                texto="Medio de pago"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona un medio de pago *"
                invalidFeedback="Debes seleccionar un medio de pago."
                :arreglo="this.catalogos.mediosPago"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.enCasoAutorizacion"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo
                texto="¿Por qué medio deseas recibir tu estado de cuenta?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona la vía para recibir tu estado de cuenta *"
                invalidFeedback="La vía para recibir el estado de cuenta es requerida."
                :arreglo="this.catalogos.tiposEnvio"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.envioEstadoCuenta"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12" style="text-align: justify">
            <div class="pl-2">
              <div v-if="this.noFactura == false" class="form-check mt-4">
                <input
                  :disabled="this.soloLectura"
                  style="font-size: 14px"
                  class="form-check-input"
                  type="checkbox"
                  v-model="DatosSolicitudGeneral.requiereFactura"
                />
                <label
                  class="form-check-label font-weight-bold terminos-solicitud"
                  >¿Requieres factura?.</label
                >
              </div>
              <div v-else class="form-check mt-4">
                <input
                  disabled
                  style="font-size: 14px"
                  class="form-check-input"
                  type="checkbox"
                  v-model="DatosSolicitudGeneral.requiereFactura"
                />
                <label
                  class="form-check-label font-weight-bold terminos-solicitud"
                  >“De acuerdo a su Régimen Fiscal este tipo de gastos no es Deducible (LISR)”</label
                >
              </div>
              <div
                class="row row-cols-lg-12 mt-3"
                v-if="this.DatosSolicitudGeneral.requiereFactura == true"
              >
                <etiqueta-campo
                  texto="Selecciona tu dirección de facturación"
                  :requerido="true"
                ></etiqueta-campo>
                <DropDown
                  :disabled="this.soloLectura"
                  placeholder="Selecciona tu dirección de facturación *"
                  :arreglo="this.catalogos.direccionesFacturacion"
                  llave="value"
                  valor="value"
                  texto="text"
                  v-model="DatosPersonaFisica.domicilioFiscal"
                  :requerido="true"
                ></DropDown>
              </div>
              <div class="row row-cols-lg-12" v-else hidden>
                <DropDown
                  disabled
                  placeholder="Selecciona tu dirección de facturación *"
                  :arreglo="this.catalogos.direccionesFacturacion"
                  llave="value"
                  valor="value"
                  texto="text"
                  v-model="DatosPersonaFisica.domicilioFiscal"
                ></DropDown>
              </div>
              <div
                v-if="
                  this.DatosPersonaFisica.domicilioFiscal == '1' &&
                    this.DatosSolicitudGeneral.requiereFactura == true
                "
                class="mt-4"
              >
                <div class="row row-cols-lg-12 w-100">
                  <strong class="titulo-seccion">Domicilio fiscal</strong>
                  <p class="parrafo-instrucciones mt-2">
                    Ingresa correctamente los datos de tu domicilio fiscal.
                  </p>
                </div>
                <div class="row row-cols-lg-12">
                  <div class="col-lg-5 columna--campos">
                    <etiqueta-campo
                      texto="Calle"
                      :requerido="true"
                    ></etiqueta-campo>
                    <input
                      :disabled="this.soloLectura"
                      placeholder="Calle * "
                      type="text"
                      class="form-control campo-basico"
                      v-model="DatosUbicacionGeneralFiscal.calle"
                      required
                    />
                  </div>
                  <div class="col-lg-3 columna--campos">
                    <etiqueta-campo
                      texto="Número"
                      :requerido="true"
                    ></etiqueta-campo>
                    <input
                      maxlength="20"
                      :disabled="this.soloLectura"
                      placeholder="Número *"
                      type="text"
                      min="0"
                      class="form-control campo-basico"
                      v-model="DatosUbicacionGeneralFiscal.numero"
                      required
                    />
                  </div>
                  <div class="col-lg-4 columna--campos">
                    <etiqueta-campo
                      texto="Código postal"
                      :requerido="true"
                    ></etiqueta-campo>
                    <input
                      :disabled="this.soloLectura"
                      placeholder="Código Postal * "
                      type="number"
                      onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                      required
                      min="0"
                      class="form-control campo-basico"
                      v-model="codigoPostalFiscal"
                      pattern="[0-9]{5}"
                    />
                  </div>
                </div>
                <div class="row row-cols-lg-12">
                  <div class="col-lg-6 columna--campos">
                    <etiqueta-campo
                      texto="Estado"
                      :requerido="true"
                    ></etiqueta-campo>
                    <input
                      placeholder="Estado *"
                      type="text"
                      class="form-control campo-basico"
                      v-model="direccionFiscal.estado"
                      disabled
                      required
                    />
                  </div>
                  <div class="col-lg-6 columna--campos">
                    <etiqueta-campo
                      texto="Delegación o municipio"
                      :requerido="true"
                    ></etiqueta-campo>
                    <input
                      placeholder="Delegación o municipio *"
                      type="text"
                      class="form-control campo-basico"
                      v-model="direccionFiscal.ciudad"
                      disabled
                      required
                    />
                  </div>
                </div>
                <div class="row row-cols-lg-12">
                  <div
                    class="col-lg-6 columna--campos"
                    v-if="
                      (codigoPostalValidoFiscal == true &&
                        catalogos.coloniasFactura.length > 0) ||
                        coloniaExistenteFiscal != null
                    "
                  >
                    <etiqueta-campo
                      texto="Colonia"
                      :requerido="true"
                    ></etiqueta-campo>
                    <DropDown
                      :disabled="this.soloLectura"
                      placeholder="Colonia *"
                      :arreglo="this.catalogos.coloniasFactura"
                      llave="coloniaId"
                      valor="coloniaId"
                      texto="descripcion"
                      v-model="DatosUbicacionFiscal.coloniaId"
                      :requerido="true"
                    ></DropDown>
                  </div>
                </div>
              </div>
              <div v-else hidden>
                <div class="row row-cols-lg-12">
                  <div class="col-lg-5">
                    <input
                      :disabled="this.soloLectura"
                      placeholder="Calle * "
                      type="text"
                      class="form-control campo-basico"
                      v-model="DatosUbicacionGeneralFiscal.calle"
                    />
                  </div>
                  <div class="col-lg-3">
                    <input
                      maxlength="20"
                      :disabled="this.soloLectura"
                      placeholder="Número *"
                      type="text"
                      min="0"
                      class="form-control campo-basico"
                      v-model="DatosUbicacionGeneralFiscal.numero"
                    />
                  </div>
                  <div class="col-lg-4">
                    <input
                      :disabled="this.soloLectura"
                      placeholder="Código Postal * "
                      type="number"
                      onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                      min="0"
                      class="form-control campo-basico"
                      v-model="codigoPostalFiscal"
                      pattern="[0-9]{5}"
                    />
                  </div>
                </div>
                <div class="row row-cols-lg-12">
                  <div class="col-lg-6">
                    <input
                      placeholder="Estado *"
                      type="text"
                      class="form-control campo-basico"
                      v-model="direccionFiscal.estado"
                      disabled
                    />
                  </div>
                  <div class="col-lg-6">
                    <input
                      placeholder="Delegación o municipio *"
                      type="text"
                      class="form-control campo-basico"
                      v-model="direccionFiscal.ciudad"
                      disabled
                    />
                  </div>
                </div>
                <div class="row row-cols-lg-12">
                  <div
                    class="col-lg-6"
                    v-if="
                      (codigoPostalValidoFiscal == true &&
                        catalogos.coloniasFactura.length > 0) ||
                        coloniaExistenteFiscal != null
                    "
                  >
                    <DropDown
                      disabled
                      placeholder="Colonia *"
                      :arreglo="this.catalogos.coloniasFactura"
                      llave="coloniaId"
                      valor="coloniaId"
                      texto="descripcion"
                      v-model="DatosUbicacionFiscal.coloniaId"
                    ></DropDown>
                  </div>
                </div>
              </div>
              <div class="form-check mt-4">
                <input
                  :disabled="this.soloLectura"
                  class="form-check-input"
                  style="font-size: 14px"
                  type="checkbox"
                  v-model="DatosSolicitudGeneral.aceptaInformacionTerceros"
                />
                <label
                  class="form-check-label font-weight-bold terminos-solicitud"
                  >Acepto que HIR Casa ceda o transmita información a terceros,
                  con fines mercadotécnicos o publicitarios, la información
                  proporcionada con motivo del presente Contrato de
                  Adhesión.</label
                >
              </div>
              <div class="form-check mt-4">
                <input
                  :disabled="this.soloLectura"
                  class="form-check-input"
                  style="font-size: 14px"
                  type="checkbox"
                  v-model="DatosSolicitudGeneral.aceptaInformacionPublicitaria"
                />
                <label
                  class="form-check-label font-weight-bold terminos-solicitud"
                  >Acepto que HIR Casa me envíe publicidad sobre bienes y
                  servicios.</label
                >
              </div>
            </div>
          </div>
          <div class="col-12">
            <button
              ref="submitUltimo"
              @click.prevent="GuardarSolicitudCompletamente"
              class="btn btn-primary"
              hidden
              type="submit"
            ></button>
          </div>
        </form>
      </div>
      <div
        class="row row-cols-lg-12 mt-2 mb-2 columna-botones"
        style="justify-content: flex-end"
      >
        <button
          type="button"
          class="boton-transparente boton-seccion-anterior"
          @click.prevent="AnteriorSeccion()"
          v-if="seccionActual != 1"
        >
          Anterior
        </button>
        <button
          type="button"
          class="boton-primario boton-siguiente-seccion"
          @click.prevent="SeccionSiguiente()"
          v-if="seccionActual != 5"
        >
          Siguiente
        </button>
        <div
          style="display: contents"
          v-if="
            (solicitudExistenteId == 0 || solicitudExistenteId == null) &&
              seccionActual == 5
          "
        >
          <button
            v-if="tipoUsuario == 0 || tipoUsuario == 2 || tipoUsuario == 5"
            disabled
            class="boton-primario boton-siguiente-seccion"
            style="opacity: 0.5; cursor: default"
          >
            Finalizar
          </button>
          <button
            v-else
            type="button"
            :disabled="this.soloLectura"
            class="boton-primario boton-siguiente-seccion"
            @click.prevent="ActivarEnvioFormulario"
          >
            <span v-if="!confirmandoDatos">Finalizar</span>
            <v-progress-circular
              v-else
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
        </div>
        <div
          style="display: contents"
          v-else-if="
            (solicitudExistenteId != 0 || solicitudExistenteId != null) &&
              seccionActual == 5
          "
        >
          <button
            v-if="tipoUsuario == 0 || tipoUsuario == 2 || tipoUsuario == 5"
            disabled
            class="boton-primario boton-siguiente-seccion"
            style="opacity: 0.5; cursor: default"
          >
            {{ NombrePasoFinal() }}
          </button>
          <button
            v-else
            type="button"
            class="boton-primario boton-siguiente-seccion"
            @click.prevent="ActivarEnvioFormulario"
          >
            <span v-if="!confirmandoDatos">{{ NombrePasoFinal() }}</span>

            <v-progress-circular
              v-else
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

//Componentes
import DropDown from "../components/DropDown.vue";
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
import Stepper from "../components/Stepper.vue";
import StepperMovil from "../components/StepperMovil.vue";
import InputFecha from "../components/InputFecha.vue"
//Plugins
import axios from "axios";
import servicios from '../../../servicios/service.js';
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
//Rutas API
const rutaGuardarSolicitud = "/api/Master/SolicitudInscripcion/GuardarSolicitudInscripcion";
const rutaGuardarSolicitudPf = "/api/Master/SolicitudInscripcion/GuardarSolicitudInscripcionPf";
const rutaCargarDatosProspecto = "/api/Master/Prospecto/ObtenerProspecto";

const prospecto = {
  params:{
    prospectoId: null
  }
}

//Validación de formularios
const forms = document.querySelectorAll('requiere-validacion')
Array.from(forms)
  .forEach(function (form) {
    form.addEventListener('submit', function (event) {
    if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
    }
      form.classList.add('was-validated')
    }, false)
  })
export default {
  name:"FormularioSolicitudInscripcion",
  components: {
    DropDown,
    VueAutonumeric,
    Stepper,
    StepperMovil,
    InputFecha
  },
  mixins: [mixinSolicitudInscripcion],
  data() {
    return {
        tieneReferencias: false,
        anchoPantalla : window.innerWidth,
        pasos: ['Datos Generales', 'Domicilio', 'Ingresos','Beneficiarios', 'Referencias' ],
        FormBeneficiarios: [
          {
            beneficiarioId: 0,
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            parentesco: null,
            porcentaje: null,
            telefono: null
          }
        ],
        FormReferencias: [
          {
            referenciaPersonalId: 0,
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            relacion: null,
            correo:null,
            aniosRelacion: null,
            telefonoParticular: null,
            telefonoMovil : null
          }
        ],
        FormReferenciasVacio: [
          {
            referenciaPersonalId: 0,
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            relacion: null,
            correo:null,
            aniosRelacion: null,
            telefonoParticular: null,
            telefonoMovil : null
          }
        ],
        datosPrueba: {
          nombre: null,
          apellido: null,
          edad: null,
          ciudad: null
        },
        mostrarSelectorUbicacionFiscal: false,
        formularioReferenciasValidado: false,
        formularioUltimoValidado: false,
        formularioValidado1: false,
        formularioValidado2: false,
        formularioValidado3: false,
        formularioValidado4: false,
        formularioValidado5: false,
        seccionActual:1,
        claseseccion: '',
        NombreCompletoProspecto: "",
        tipoUsuario: null,
        //Propiedades del autonumeric
        opcionesAutoNumeric: {
          digitGroupSeparator: ',',
          decimalCharacter: '.',
          decimalCharacterAlternative: '.',
          currencySymbol: '$',
          currencySymbolPlacement: 'p',
          roundingMethod: 'U',
          minimumValue: '0',
          maximumValue: '15000000'
        },
        solicitudExistenteId: 0,
        ProspectoId: null,
        codigoPostalValido: false,
        codigoPostalValidoEmpresa:false,
        codigoPostalValidoFiscal: false,
        direccion:{
          ciudad:"",
          estado:""
        },
        direccionEmpresa:{
          ciudad:"",
          estado:""
        },
        direccionFiscal:{
          ciudad:"",
          estado:""
        },
        catalogos: {
            productos: [],
            servicios: [],
            paises:[],
            sexos:[],
            tiposIdentificacion: [],
            estadosCiviles: [],
            regimenesMatrimoniales: [],
            colonias: [],
            coloniasEmpresa:[],
            coloniasFactura:[],
            profesiones: [],
            tiposVivienda: [],
            gradosEstudio:[],
            divisas:[],
            tiposEmpleo: [],
            tiposIngreso: [],
            tiposEnvio:[],
            parentescos: [],
            mediosPago: [],
            giros: [],
            puestos: [],
            regimenesFiscales: [],
            direccionesFacturacion: [
              {
                "text": "Misma que domicilio personal",
                "value": "0"
              },
              {
                "text": "Otra",
                "value": "1"
              },
            ],
        referencias: [
          { text: "Si", value: true },
          { text: "No", value: false },
        ],
        },
        DatosSolicitudGeneral: {
            solicitudId: 0,
            prospectoId:null,
            producto: null,
            servicio: null,
            fechaRegistroSolicitud:null,
            fechaNacimiento: null,
            envioEstadoCuenta:null,
            envioEstadoCuentaOriginal:null,
            enCasoAutorizacion : null,
            requiereFactura:false,
            aceptaInformacionTerceros: false,
            aceptaInformacionPublicitaria: false,
            seccionActual: null,
            solicitudCompletada: false,
        },
        DatosPersonaFisica: {
          solicitudId: 0,
          nombreConyuge: "",
          nombres: "",
          apellidoPaterno: "",
          apellidoMaterno: "",
          rfc: "",
          numeroIdentificacion: null,
          nacionalidad: 154,
          sexo: null,
          lugarNacimiento: 154,
          curp: "",
          tipoIdentificacion: null,
          estadoCivil: null,
          regimenMatrimonial: null,
          gradoEstudios: null,
          profesion: null,
          regimenFiscal: null,
          numeroDependientes: null,
          egresoMensual: null,
          tipoVivienda: null,
          tipoEmpleo: null,
          departamentoEmpleo: null,
          domicilioFiscal: null,
          regimenFiscalId: null,
      },
        DatosUbicacionGeneralParticular: {
            ubicacionId : 0,
            prospectoId: null,
            tipoUbicacion:0,
            calle: null,
            numero: null,
            direccionFacturacion: false
        },
        DatosUbicacionGeneralOficina: {
            ubicacionId : 0,
            prospectoId: null,
            tipoUbicacion:1,
            calle: null,
            numero: null,
            direccionFacturacion: false
        },
        DatosUbicacionGeneralFiscal: {
            ubicacionId : 0,
            prospectoId: null,
            tipoUbicacion:2,
            calle: null,
            numero: null,
            direccionFacturacion: false
        },
        DatosUbicacionParticular: {
          ubicacionId:null,
          coloniaId: null,
          coloniaIdOriginal: null
        },        
        DatosUbicacionOficina: {
          ubicacionId:null,
          coloniaId: null,
          coloniaIdOficinaOriginal: null
        },
        DatosUbicacionFiscal: {
          ubicacionId:null,
          coloniaId: null,
          coloniaIdFiscalOriginal: null
        },
        codigoPostalOficina: null,
        codigoPostalParticular:null,
        codigoPostalFiscal:null,
        PuntosContacto: [],

        PuntoContactoConyuge: {
          telefonoFijoConyuge: {
            puntoContactoId: 0,
            valor: null,
          },
          telefonoMovilConyuge: {
            puntoContactoId: 0,
            valor: null,
          },
          correoConyuge: {
            puntoContactoId: 0,
            valor: null,
          },
        },

        PuntoContactoGeneral:{
          telefonoFijo: {
            puntoContactoId: 0,
            valor: null
          },
          telefonoMovil:{
            puntoContactoId: 0,
            valor: null
          },
          correo1: {
            puntoContactoId: 0,
            valor: null
          },
          correo2: {
            puntoContactoId: 0,
            valor: null
          },
          telefonoFijoOficina: {
            puntoContactoId: 0,
            valor: null
          },
        },
        DatosIngreso: {
          ingresoId:0,
          prospectoId: null,
          tipoIngreso: null,
          divisa:null,
          empresa: "",
          giroEmpresa: "",
          puesto:"",
          otroPuesto:"",
          giroEmpresaId: null,
          puestoId: null,
          monto: null,
          antiguedadMeses:null,
          antiguedadAnios: null,
          utilidad:null,
          esPersonaMoral: false
        },
        //auxiliares
        coloniaExistenteParticular: null,
        coloniaExistenteOficina: null,
        coloniaExistenteFiscal: null,
        soloLectura: false,
        esRepresentante: false,
        ProspectoMoralId: null,
        rfcValido: false,
        curpValido: false,
        edadProspecto: null,
        esMayorDeEdad: false,
        referenciasTieneDatos:false,
        etapaProspecto: null,
        etapaProspectoMoral: null,
        confirmandoDatos: false,
        noFactura: false
    }
  },
  computed: {
    camposVaciosBeneficiarioForm: function() {
      const formulario = this.FormBeneficiarios[this.FormBeneficiarios.length - 1];
      const clavesIgnoradas = ["apellidoMaterno", "beneficiarioId", "solicitudId"];
      const estaVacioONulo = (valor) => valor === "" || valor === null;
      const esConyuge = (valor) => valor === 0;
      let vacios = 0;

      for (const clave in formulario) {
        if (!clavesIgnoradas.includes(clave)) {
          const valor = formulario[clave];
          if (clave === "parentesco") {
            if (!esConyuge(valor) && estaVacioONulo(valor)) {
              vacios++;
            }
          } else {
            if (estaVacioONulo(valor) || valor < -1) {
              vacios++;
            }
          }
        }
      }
      return vacios > 0;
    },
    camposVaciosReferenciaForm: function() {
      console.log("revisando")
      const formulario = this.FormReferencias[this.FormReferencias.length - 1];
      const clavesIgnoradas = ["apellidoMaterno", "referenciaPersonalId", "correo", "telefonoParticular"];
      const estaVacioONulo = (valor) => valor === "" || valor === null;
      const esConyuge = (valor) => valor === 0;
      let vacios = 0;
      for (const clave in formulario) {
        if (!clavesIgnoradas.includes(clave)) {
          const valor = formulario[clave];

          if (clave === "relacion") {
            if (!esConyuge(valor) && (estaVacioONulo(valor) || valor < 0)) {
              vacios++;
            }
          } else {
            if (estaVacioONulo(valor) || valor < 0) {
              vacios++;
            }
          }
        }
      }
      return vacios > 0;
    },
  },
   async mounted (){
     //Se cargan todos los datos para los dropdown's
    await this.CargarProductos(false);
    await this.CargarServicios(false);
    await this.CargarPaises(false);
    await this.CargarSexos(false);
    await this.CargarTiposIdentificacion(false);
    await this.CargarProfesiones(false);
    await this.CargarTiposVivienda(false);
    await this.CargarTiposIngreso(false);
    await this.CargarGradosEstudio(false);
    await this.CargarDivisas(false);
    await this.CargarMediosPago(false);
    await this.CargarTiposEmpleo(false);
    await this.CargarTiposEnvioEC(false);
    await this.CargarParentescos(false);
    await this.CargarEstadosCiviles(false);
    await this.CargarRegimenesMatrimoniales(false);
    await this.CargarPuestos(false);
    await this.CargarGiros(false);
    await this.CargarRegimenesFiscales(false, false);
    //Se verifica que tipo de prospecto es para obtener su id
    this.esRepresentante = this.$route.params["esRepresentante"];
    if(this.esRepresentante == true) {
      this.ProspectoId = this.$store.getters.prospectoId;
      //Comenzamos a cargar los datos del prospecto
      let identificadores = await this.ObtenerPersonaMoral(this.ProspectoId);
      this.ProspectoId = identificadores.representanteLegalProspectoId;
      this.ProspectoMoralId =  identificadores.prospectoId;
      await this.ConsultarSolicitudes(this.ProspectoId, true);
      this.solicitudExistenteId = this.SolicitudRepresentanteId;
      this.CargarDatosProspectoMoral(this.ProspectoMoralId);
    } else {
      this.ProspectoId = this.$store.getters.prospectoId;
      this.solicitudExistenteId = this.$store.getters.solicitudFisicaId;
    }

    prospecto.params.prospectoId = this.ProspectoId;

    this.CargarDatosProspecto(this.ProspectoId);
    this.DatosSolicitudGeneral.prospectoId = parseInt(this.ProspectoId);
    this.DatosUbicacionGeneralParticular.prospectoId = parseInt(this.ProspectoId);
    this.DatosUbicacionGeneralOficina.prospectoId = parseInt(this.ProspectoId);
    this.DatosUbicacionGeneralFiscal.prospectoId = parseInt(this.ProspectoId);
    this.DatosIngreso.prospectoId = parseInt(this.ProspectoId);

    //Se obtiene la solicitud
    if(this.solicitudExistenteId != 0) {
      await this.ConsultarSolicitudGeneral();
      await this.ConsultarSolicitudPersonaFisica();
      this.ConsultarUbicaciones(this.ProspectoId);
      await this.ConsultarPerfilIngreso();
      this.ConsultarBeneficiariosTest();
      this.ConsultarReferenciasTest();

      this.VerificarSoloLectura();
     }
     this.tipoUsuario = this.$store.getters.tipoUsuario;
     let datos = (await this.ObtenerDatosProspecto(this.ProspectoId)).data.data;

    this.NombreCompletoProspecto = "SOLICITUD DE INSCRIPCIÓN PERSONA FÍSICA: " + datos.nombres + " " + datos.apellidoPaterno + " " + datos.apellidoMaterno;

     this.etapaProspecto = datos.etapaId;
     if(this.etapaProspecto > 4)
     {this.soloLectura = true;}

     if(this.etapaProspecto > 4)
     {
      this.seccionActual = 1;
     }

     if (this.tipoUsuario != 3) {
              this.seccionActual = 1;
            }
if(this.DatosPersonaFisica.regimenFiscalId != null)
{
     if(this.DatosPersonaFisica.regimenFiscalId == 1 || this.DatosPersonaFisica.regimenFiscalId == 3 || this.DatosPersonaFisica.regimenFiscalId == 4 ||
      this.DatosPersonaFisica.regimenFiscalId == 5 || this.DatosPersonaFisica.regimenFiscalId == 6 || this.DatosPersonaFisica.regimenFiscalId == 8 ||
      this.DatosPersonaFisica.regimenFiscalId == 9 || this.DatosPersonaFisica.regimenFiscalId == 10)
      {
        this.noFactura = true;
        this.DatosSolicitudGeneral.requiereFactura = false;
        this.DatosPersonaFisica.domicilioFiscal = null;
        this.DatosUbicacionGeneralFiscal.calle = null;
        this.DatosUbicacionGeneralFiscal.numero = null;
        this.DatosUbicacionFiscal.coloniaId = null;
        this.catalogos.coloniasFactura = [];
      }
      else{
        this.noFactura = false;
      }
}
  },
  watch: {
   'DatosPersonaFisica.regimenFiscalId': function () {
      if(this.DatosPersonaFisica.regimenFiscalId == 1 || this.DatosPersonaFisica.regimenFiscalId == 3 || this.DatosPersonaFisica.regimenFiscalId == 4 ||
      this.DatosPersonaFisica.regimenFiscalId == 5 || this.DatosPersonaFisica.regimenFiscalId == 6 || this.DatosPersonaFisica.regimenFiscalId == 8 ||
      this.DatosPersonaFisica.regimenFiscalId == 9 || this.DatosPersonaFisica.regimenFiscalId == 10)
      {
        this.noFactura = true;
        this.DatosSolicitudGeneral.requiereFactura = false;
        this.DatosPersonaFisica.domicilioFiscal = null;
        this.DatosUbicacionGeneralFiscal.calle = null;
        this.DatosUbicacionGeneralFiscal.numero = null;
        this.DatosUbicacionFiscal.coloniaId = null;
        this.catalogos.coloniasFactura = [];
      }
      else{
        this.noFactura = false;
      }
    },
   'DatosPersonaFisica.rfc': function () {
      this.DatosPersonaFisica.rfc = this.DatosPersonaFisica.rfc.toUpperCase();
    },
    'DatosSolicitudGeneral.requiereFactura' : function () {
      if(this.DatosSolicitudGeneral.requiereFactura == false){
        this.DatosPersonaFisica.domicilioFiscal = null;
        this.DatosUbicacionGeneralFiscal.calle = null;
        this.DatosUbicacionGeneralFiscal.numero = null;
        this.DatosUbicacionFiscal.coloniaId = null;
        this.catalogos.coloniasFactura = [];
      }
    },
    FormBeneficiarios : {
      handler: function (value) {
        value.forEach(item => {
          item.porcentaje = item.porcentaje == "" ? 0 : Math.trunc(servicios.EvitarNegativos(item.porcentaje));
          item.telefono = servicios.LimitarTelefonoLocal(item.telefono);
        });

      },
      deep: true
    },
    FormReferencias: {
      handler : function (value) {
        value.forEach(item => {
          item.telefonoParticular = servicios.EvitarNegativos( item.telefonoParticular);
          item.telefonoParticular = servicios.LimitarTelefonoLocal( item.telefonoParticular);
          item.telefonoMovil = servicios.EvitarNegativos( item.telefonoMovil);
          item.telefonoMovil = servicios.LimitarTelefonoLocal( item.telefonoMovil);
        });
      },
      deep: true
    },
    'DatosIngreso.divisa': function () {
      if(this.DatosIngreso.divisa == 3){
        this.opcionesAutoNumeric = {
          currencySymbol : ' €',
          decimalCharacter : ',',
          digitGroupSeparator : '.',
          currencySymbolPlacement: 'p',
        }
      } else {
        this.opcionesAutoNumeric = {
          digitGroupSeparator: ',',
          decimalCharacter: '.',
          decimalCharacterAlternative: '.',
          currencySymbol: '$',
          currencySymbolPlacement: 'p',
          roundingMethod: 'U',
          minimumValue: '0',
          maximumValue: '15000000'
        }
      }
    },
    'DatosPersonaFisica.domicilioFiscal': function () {
      if(this.DatosPersonaFisica.domicilioFiscal == "0") {
        this.DatosUbicacionGeneralParticular.direccionFacturacion = true;
        this.DatosUbicacionGeneralFiscal.direccionFacturacion = false;
      } else if(this.DatosPersonaFisica.domicilioFiscal == "1") {
        this.DatosUbicacionGeneralParticular.direccionFacturacion = false;
        this.DatosUbicacionGeneralFiscal.direccionFacturacion = true;
      }

    },
     'PuntoContactoConyuge.telefonoFijoConyuge.valor' : function() {
      this.PuntoContactoConyuge.telefonoFijoConyuge.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoConyuge.telefonoFijoConyuge.valor);
    },
    'PuntoContactoConyuge.telefonoMovilConyuge.valor' : function() {
      this.PuntoContactoConyuge.telefonoMovilConyuge.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoConyuge.telefonoMovilConyuge.valor);
    },
    'PuntoContactoGeneral.telefonoFijo.valor' : function() {
      this.PuntoContactoGeneral.telefonoFijo.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoFijo.valor);
    },
    'PuntoContactoGeneral.telefonoMovil.valor' : function() {
      this.PuntoContactoGeneral.telefonoMovil.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoMovil.valor);
    },
    'PuntoContactoGeneral.telefonoFijoOficina.valor' : function() {
      this.PuntoContactoGeneral.telefonoFijoOficina.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoFijoOficina.valor);
    },
    'PuntoContactoGeneral.telefonoMovilOficina.valor' : function() {
      this.PuntoContactoGeneral.telefonoMovilOficina.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoMovilOficina.valor);
    },
    'codigoPostalFiscal' : function () {
      if (this.codigoPostalFiscal == "") this.InvalidarCodigoPostal('fiscal');
      if(this.codigoPostalFiscal.length < 5) this.InvalidarCodigoPostal('fiscal');
      if(this.codigoPostalFiscal.length > 5) this.codigoPostalFiscal = this.codigoPostalFiscal.toString().substring(0,5);
      if(this.codigoPostalFiscal.length == 5 )
        if(this.codigoPostalFiscal == "00000")
          this.InvalidarCodigoPostal('fiscal');
        else
          this.ConsultarCodigoPostal(this.codigoPostalFiscal, 2)
          ;
    },
    'codigoPostalParticular' : function() {
      if (this.codigoPostalParticular == "") this.InvalidarCodigoPostal('particular');
      if(this.codigoPostalParticular.length < 5) this.InvalidarCodigoPostal('particular');
      if(this.codigoPostalParticular.length > 5) this.codigoPostalParticular = this.codigoPostalParticular.toString().substring(0,5);
      if(this.codigoPostalParticular.length == 5 )
        if(this.codigoPostalParticular == "00000")
          this.InvalidarCodigoPostal('particular');
        else
          this.ConsultarCodigoPostal(this.codigoPostalParticular, 0)         
    },
    'codigoPostalOficina' : function() {
      if(this.codigoPostalOficina == "") this.InvalidarCodigoPostal('oficina');
      if(this.codigoPostalOficina.length < 5) this.InvalidarCodigoPostal('oficina');
      if(this.codigoPostalOficina.length > 5) this.codigoPostalOficina = this.codigoPostalOficina.toString().substring(0,5);
      if(this.codigoPostalOficina.length == 5 )
        if(this.codigoPostalOficina == "00000")
          this.InvalidarCodigoPostal('oficina');
        else
          this.ConsultarCodigoPostal(this.codigoPostalOficina, 1);
    },
    'DatosUbicacionGeneralOficina.calle' : function () {
      this.DatosUbicacionGeneralOficina.calle = this.DatosUbicacionGeneralOficina.calle == "" ? null : this.DatosUbicacionGeneralOficina.calle;
    },
    'DatosUbicacionGeneralOficina.numero' : function () {
      this.DatosUbicacionGeneralOficina.numero = this.DatosUbicacionGeneralOficina.numero == "" ? null : this.DatosUbicacionGeneralOficina.numero;
    },
    'DatosReferencia.aniosRelacion' : function () {
      this.DatosReferencia.aniosRelacion = servicios.EvitarNegativos(this.DatosReferencia.aniosRelacion);
      if(this.DatosReferencia.aniosRelacion > 100)
        this.DatosReferencia.aniosRelacion = 100;
    },
    'DatosIngreso.antiguedadAnios' :function () {
        this.DatosIngreso.antiguedadAnios = servicios.EvitarNegativos(this.DatosIngreso.antiguedadAnios);
        if(this.DatosIngreso.antiguedadAnios > 65)
          this.DatosIngreso.antiguedadAnios = 65;
    },
    'DatosIngreso.antiguedadMeses' :function () {
      this.DatosIngreso.antiguedadMeses = servicios.EvitarNegativos(this.DatosIngreso.antiguedadMeses);
      if(this.DatosIngreso.antiguedadMeses > 12)
        this.DatosIngreso.antiguedadMeses = 12;
    },
    'DatosReferencia.telefonoParticular' : function () {
      this.DatosReferencia.telefonoParticular = servicios.EvitarNegativos(this.DatosReferencia.telefonoParticular);
      this.DatosReferencia.telefonoParticular = servicios.LimitarTelefonoLocal(this.DatosReferencia.telefonoParticular);
    },
    'DatosReferencia.telefonoMovil' : function () {
      this.DatosReferencia.telefonoMovil = servicios.EvitarNegativos(this.DatosReferencia.telefonoMovil);
      this.DatosReferencia.telefonoMovil = servicios.LimitarTelefonoLocal(this.DatosReferencia.telefonoMovil);
    },
    'DatosPersonaFisica.numeroDependientes': function () {
      this.DatosPersonaFisica.numeroDependientes = this.DatosPersonaFisica.numeroDependientes < 1 ? 0 : this.DatosPersonaFisica.numeroDependientes;
      if(this.DatosPersonaFisica.numeroDependientes > 10)
        this.DatosPersonaFisica.numeroDependientes = 10;
    },
    'DatosSolicitudGeneral.fechaNacimiento' : function () {
      var fechaNacimiento = new Date(
        this.DatosSolicitudGeneral.fechaNacimiento
      );
      this.esMayorDeEdad = servicios.EsMayorDeEdad(fechaNacimiento);
    }
  },
  methods: {
 NombrePasoFinal(){
      return this.etapaProspecto > 5 ? "Cerrar" : "Actualizar" ;
    },
    LimitarPorcentaje(index){
      this.FormBeneficiarios[index].porcentaje = this.FormBeneficiarios[index].porcentaje != null ? parseFloat(this.FormBeneficiarios[index].porcentaje) : 0;
      
      if(this.FormBeneficiarios.length == 1){
          if(this.FormBeneficiarios[0].porcentaje > 100) {
            this.FormBeneficiarios[0].porcentaje = 100;
          }
        } else {
            if(this.SumaPorcentajes() > 100){
              let resta = this.SumaPorcentajes() - this.FormBeneficiarios[index].porcentaje;
              let faltante = 100 - resta;
              this.FormBeneficiarios[index].porcentaje = faltante;
            }
        }
    },
    ValidarCorreoReferencia(index){
      const regexCorreo = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(this.FormReferencias.length == 1){
          if(!regexCorreo.test(this.FormReferencias[0].correo.toLowerCase())) {
            this.AlertaEmbajadores("El correo electrónico no tiene un formato válido", true);
            this.FormReferencias[0].correo = "";
          }
        } else {
              if(!regexCorreo.test(this.FormReferencias[index].correo.toLowerCase())) {
                this.AlertaEmbajadores("El correo electrónico no tiene un formato válido", true);
                this.FormReferencias[index].correo = "";
              }
        }
    },
    SeccionSiguiente(){
      switch (this.seccionActual) {
        case 1:
          this.$refs.submitUno.click();
          break;
        case 2:
          this.$refs.submitDos.click();
          break;
        case 3:
          this.$refs.submitTres.click();
          break;
        case 4:
          //Validaciones de beneficiarios
          if(this.FormBeneficiarios.length > 0) {
            let camposVacios = 0;
            for (var beneficiario of this.FormBeneficiarios) {
              if(this.CamposActualesVacios(this.FormBeneficiarios.indexOf(beneficiario))){
                camposVacios++;
              }
            }
            if(camposVacios > 0){
              this.AlertaEmbajadores("No has llenado todos los campos requeridos en algunos de tus beneficiarios.",true)
              return;
            } else {
              for(var b of this.FormBeneficiarios){
                if (b.telefono == null || b.telefono.length != 10) {
                  this.AlertaEmbajadores("El teléfono de alguno de tus beneficiarios debe de contar con 10 dígitos.",true);
                  return;
                }
              }
              if(this.SumaPorcentajes() == 100) {
                this.seccionActual++;
              } else{
                this.AlertaEmbajadores("Los beneficiarios deben sumar un total de 100%", true);
                return;
              }
            }
          } else {
            this.AlertaEmbajadores("Debe ingresar al menos un beneficiario.", true);
          return;
          }
          break;
      }
    },
    AnteriorSeccion(){
      if(this.seccionActual != 1) {
        this.seccionActual--;
        window.scrollTo(0, 0);
      }
    },
    ValidaFormSiguiente(){
      let formularioValidado = false;
      switch (this.seccionActual) {
        case 1:
            this.formularioValidado1 = true;
            formularioValidado = this.$refs.formularioUno.checkValidity();
            break;
        case 2:
          this.formularioValidado2 = true;
          formularioValidado = this.$refs.formularioDos.checkValidity();
          break;
        case 3:
          this.formularioValidado3 = true;
          formularioValidado = this.$refs.formularioTres.checkValidity();
          break;
      }

      if(formularioValidado) {
        if(this.seccionActual == 1) {
          if(this.ValidarRFC() == false){
            this.AlertaEmbajadores('Por favor verifica que el formato del RFC sea válido.',true);
            return;
          }
          if(this.ValidarCURP() == false){
             this.AlertaEmbajadores("La curp ingresada: " + this.DatosPersonaFisica.curp.toUpperCase()
             + " no cuenta con la longitud de 18 el formato establecido 4 Letras, 6 números, 6 letras, un número o letra y un número o no coincide con la fecha ingresada", true);
             return;
          }
          if(this.DatosSolicitudGeneral.fechaNacimiento == null) {
            this.AlertaEmbajadores("Por favor indica tu fecha de nacimiento.", true);
            return;
          } else if(!this.esMayorDeEdad){
            this.AlertaEmbajadores("Se debe cumplir la mayoria de edad para continuar el proceso.", true);
            return;
          }  else {
            this.seccionActual++;
             window.scrollTo(0, 0);
          }
        } else if(this.seccionActual == 2) {
          if(this.PuntoContactoGeneral.telefonoFijo.valor != null){
            if(this.PuntoContactoGeneral.telefonoFijo.valor.length != 10){
              this.AlertaEmbajadores("El teléfono debe de contar con 10 dígitos",true);
              return;
            }
          }
          if(this.codigoPostalValido == false) {
            this.AlertaEmbajadores("Por favor verifica que los datos de tu domicilio sean correctos.", true);
            return;
          } else {
            this.seccionActual++;
             window.scrollTo(0, 0);
          }
        } else if(this.seccionActual == 3){
          if(this.PuntoContactoGeneral.telefonoFijoOficina.valor != null){
            if (this.PuntoContactoGeneral.telefonoFijoOficina.valor.length != 10) {
              this.AlertaEmbajadores("El teléfono debe de contar con 10 dígitos.", true);
              return;
            }
          }
          if(this.DatosUbicacionGeneralOficina.calle != null || this.DatosUbicacionGeneralOficina.numero != null || this.codigoPostalOficina != null) {
            if(this.codigoPostalValidoEmpresa == false) {
              this.AlertaEmbajadores("Por favor verifica que los datos del domicilio de la empresa sean correctos o estén completos.", true);
              return;
            } else {
              this.seccionActual++;
               window.scrollTo(0, 0);
            }
          } else {
            this.seccionActual++;
             window.scrollTo(0, 0);
          }
        }  else if(this.seccionActual != 5){
          this.seccionActual++;
           window.scrollTo(0, 0);
        }
      }

    },
    ValidarRFC(){
        var rfcValido = true;
        //Se valida Estructura
        var regExpCHRfc = /^([A-ZÑ]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([0-9-A-Z\\d]{3})?$/;
        var rfcValidadoEstructura = regExpCHRfc.test(this.DatosPersonaFisica.rfc);

        if (rfcValidadoEstructura == false) {
          rfcValido = false;
        }
        //Validar la fecha
        var rfcArray ='';
        rfcArray = this.DatosPersonaFisica.rfc.split("");

        var anio = rfcArray[4] + '' +   rfcArray[5];
        if (anio > 19) {
          anio = '19' + '' + anio;
        }else{
          anio = '20' + '' + anio;
        }

        var mes =  rfcArray[6] + '' + rfcArray[7];
        var dia =  rfcArray[8] + '' + rfcArray[9];
        var fechaCurpRfc = anio + '-' + mes + '-' + dia;

        if (fechaCurpRfc != this.DatosSolicitudGeneral.fechaNacimiento) {
          rfcValido = false;
        }

        return rfcValido;
    },


    ValidarCURP(){

        var curpValido = true;

      //Se valida Estructura

       var regExpCurp = /[a-zA-Z]{1}[aeiouAEIOU]{1}[a-zA-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[hmHM]{1}(as|AS|bc|BC|bs|BS|cc|CC|cs|CS|ch|CH|cl|CL|cm|CM|df|DF|dg|DG|gt|GT|gr|GR|hg|HG|jc|JC|mc|MC|mn|MN|ms|MS|nt|NT|nl|NL|oc|OC|pl|PL|qt|QT|qr|QR|sp|SP|sl|SL|sr|SR|tc|TC|ts|TS|tl|TL|vz|VZ|yn|YN|zs|ZS|ne|NE)[0-9a-zA-Z]{3}[0-9a-zA-Z]{1}[0-9a-zA-Z]{1}$/;
       var curpValidadoEstructura = regExpCurp.test(this.DatosPersonaFisica.curp);

        if (curpValidadoEstructura == false) {
            curpValido = false;
        }

        //Validar la fecha

        var curpArray ='';
        curpArray = this.DatosPersonaFisica.curp.split("");

        var anio = curpArray[4] + '' +   curpArray[5];
        if (anio > 19) {
          anio = '19' + '' + anio;
        }else{
          anio = '20' + '' + anio;
        }

        var mes =  curpArray[6] + '' + curpArray[7];
        var dia =  curpArray[8] + '' + curpArray[9];
        var fechaCurpRfc = anio + '-' + mes + '-' + dia;

        if (fechaCurpRfc != this.DatosSolicitudGeneral.fechaNacimiento) {
            curpValido = false;
        }

       return curpValido;
    },
    ValidarDatosCurpRfc(cadenaCurpRfc) {
        var curpRfcArray ='';
        curpRfcArray = cadenaCurpRfc.split("");
        var curpRfcValido = true;

        //Validar la fecha

        var anio = curpRfcArray[4] + '' +   curpRfcArray[5];
        if (anio > 19) {
          anio = '19' + '' + anio;
        }else{
          anio = '20' + '' + anio;
        }

        var mes =  curpRfcArray[6] + '' + curpRfcArray[7];
        var dia =  curpRfcArray[8] + '' + curpRfcArray[9];
        var fechaCurpRfc = anio + '-' + mes + '-' + dia;

        if (fechaCurpRfc != this.DatosSolicitudGeneral.fechaNacimiento) {
          curpRfcValido = false;
        }

        //Validar el nombre

        var primerVocalApellido = "";

        var apellidoPaterno = curpRfcArray[0] + '' +   curpRfcArray[1];
        var apellidoMaterno = curpRfcArray[2];
        var primerNombre = curpRfcArray[3];

        var codigoNombreCurpRfc = apellidoPaterno + apellidoMaterno + primerNombre;

        var apellidoPaternoProspecto = this.DatosPersonaFisica.apellidoPaterno;
        var apellidoMaternoProspecto = this.DatosPersonaFisica.apellidoMaterno;
        var primerNombreProspecto = this.DatosPersonaFisica.nombres;

        var apellidoPaternoArray ='';
        apellidoPaternoArray = apellidoPaternoProspecto.split("");

        for (let index = 1; index < apellidoPaternoArray.length; index++) {
          if (apellidoPaternoArray[index] == "A" || apellidoPaternoArray[index] == "E" || apellidoPaternoArray[index] == "I" || apellidoPaternoArray[index] == "O" || apellidoPaternoArray[index] == "U") {
            primerVocalApellido = apellidoPaternoArray[index];
            break;
          }
        }

        apellidoPaternoProspecto = apellidoPaternoProspecto.charAt(0) + primerVocalApellido;
        apellidoMaternoProspecto = apellidoMaternoProspecto.charAt(0);
        primerNombreProspecto = primerNombreProspecto.charAt(0);

        var codigoNombreProspecto = apellidoPaternoProspecto + apellidoMaternoProspecto + primerNombreProspecto;

        if (codigoNombreCurpRfc != codigoNombreProspecto) {
          curpRfcValido = false;
        }

      return curpRfcValido;
    },
    ObtenerStringRelacion(relacion) {
      return servicios.ObtenerStringRelacion(parseInt(relacion));
    },
    GuardarBorradorSolicitud() {
      if(this.seccionActual == 1) {
        let camposLlenos = 0;
        var llaves = Object.keys(this.DatosSolicitudGeneral);
        llaves.forEach((llave) => {
          if(typeof this.DatosSolicitudGeneral[llave] != "boolean")
            if((llave != "solicitudId" && llave != "prospectoId" && llave != "seccionActual") && this.DatosSolicitudGeneral[llave] != null)
              camposLlenos ++;
        });
        if(camposLlenos >= 1) {
          this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
          this.AjustarTiposDeDatos();
          this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
        } else {
          this.AlertaEmbajadores("Para guardar tu progreso debes llenar al menos un campo.", true);
        }
      }else if(this.seccionActual == 2) {
        if(this.codigoPostalValido == false){
          this.AlertaEmbajadores("Para guardar tu progreso verifica que los datos de tu domicilio sean correctos.", true);
          return;
        } else {
          this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
          this.AjustarTiposDeDatos();
          this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
        }
      } else if(this.seccionActual == 3) {
        if(this.DatosUbicacionGeneralOficina.calle != null || this.DatosUbicacionGeneralOficina.numero != null || this.codigoPostalOficina != null){
          if(this.codigoPostalValidoEmpresa == false) {
            this.AlertaEmbajadores("Para guardar tu progreso verifica que los datos del domicilio de la empresa sean correctos y estén completos.", true);
            return;
          } else {
            this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
            this.AjustarTiposDeDatos();
            this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
          }
        } else {
          this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
          this.AjustarTiposDeDatos();
          this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
        }
      }else if(this.seccionActual == 4){
        let camposVacios = 0;
        for (var beneficiario of this.FormBeneficiarios) {
         if(this.CamposActualesVacios(this.FormBeneficiarios.indexOf(beneficiario))){
           camposVacios++;
         }
        }
        if(camposVacios > 0){
          this.AlertaEmbajadores("No has llenado todos los campos requeridos en algunos de tus beneficiarios.",true)
          return;
        } else {
          this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
          this.AjustarTiposDeDatos();
          this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
        }
      } else {
        this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
        this.AjustarTiposDeDatos();
        this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
      }
    },
    GuardarSolicitudCompletamente(){
      if(this.etapaProspecto > 5) return;

      let formularioValidado = false;
      this.formularioUltimoValidado = true;
      formularioValidado = this.$refs.formularioUltimo.checkValidity();

      if(formularioValidado) {
        if(this.DatosSolicitudGeneral.requiereFactura == true && this.DatosPersonaFisica.domicilioFiscal == "1") {
          if(this.codigoPostalValidoFiscal == false) {
            this.AlertaEmbajadores("Por favor verifica que los datos de tu domicilio fiscal sean correctos.", true);
            return;
          } else {
            //Se guarda toda la solicitud
            this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
            this.DatosSolicitudGeneral.solicitudCompletada = true;
            this.AjustarTiposDeDatos();
            this.GuardarSolicitud(this.DatosSolicitudGeneral, false);
          }
        } else {
          //Se guarda toda la solicitud
          this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
          this.DatosSolicitudGeneral.solicitudCompletada = true;
          this.AjustarTiposDeDatos();
          this.GuardarSolicitud(this.DatosSolicitudGeneral, false);
        }
      }
    },
    ActivarEnvioFormulario() {
      if(this.etapaProspecto <= 5)
      {this.$refs.submitUltimo.click();}
     else {
        if (this.$route.params.vieneDeAdministracion != undefined) {
          if (this.esRepresentante == true)
            this.$router.push({
              name: "IntegracionExpedienteMoral",
              params: {
                prospectoId: this.ProspectoMoralId,
                vieneDeAdministracion: true,
              },
            });
          else
            this.$router.push({
              name: "IntegracionExpediente",
              params: {
                prospectoId: this.ProspectoId,
                vieneDeAdministracion: true,
              },
            });
        } else {
          if (this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
            if (this.esRepresentante == true) {
              if (this.etapaProspectoMoral == 4) {
                this.$router.push({
                  name: "IntegracionExpedienteMoral",
                  params: { prospectoId: this.ProspectoMoralId },
                });
              }
            } else {
              if (this.personaFisicaFiguraAdicional.EtapaId == 4) {
                this.$router.push({
                  name: "IntegracionExpediente",
                  params: { prospectoId: this.ProspectoId },
                });
              }
            }
          } else {
              this.$router.push({
                name: "IntegracionExpediente",
                params: { prospectoId: this.ProspectoId },
              });
          }
        }
      }
    },
    //Validaciones
    GuardarSolicitud(solicitudGeneral, esBorrador){
      this.confirmandoDatos= true
      const solicitudPersonaFisica = this.DatosPersonaFisica;
      axios.post(rutaGuardarSolicitud, solicitudGeneral)
        .then(resp => {
          if (resp.data.estado === 0) {
            let solicitudId = resp.data.data;
            this.DatosPersonaFisica.solicitudId = solicitudId;

        if(this.FormReferencias.length > 0)
        {
            if(this.ValidarRerencias(false) != 'validas'){
              this.AlertaEmbajadores(this.ValidarRerencias(false), true);
              this.confirmandoDatos = false
              return;
            } else {
              this.GuardarReferenciasTest(solicitudId);
            }
        }
            this.GuardarSolicitudPF(solicitudPersonaFisica);
            this.GuardarUbicacionGeneralParticular();
            this.GuardarUbicacionGeneralOficina();
            if(this.DatosSolicitudGeneral.requiereFactura == true && this.DatosPersonaFisica.domicilioFiscal == "1") {
              this.GuardarUbicacionGeneralFiscal();
            }else{
              this.confirmandoDatos = false
            }
            if(this.ValidarMinimoCamposIngreso()) {
              this.GuardarIngresos(this.DatosIngreso);
            }else{
              this.confirmandoDatos = false
            }

            this.solicitudExistenteId != 0 ? this.GuardarPuntosDeContacto(true, false) : this.GuardarPuntosDeContacto(true,true);
            
            if(this.DatosPersonaFisica.estadoCivil == 1)
            {
            this.solicitudExistenteId != 0 ? this.GuardarPuntosDeContactoConyuge(true, false) : this.GuardarPuntosDeContactoConyuge(true,true);
            }

            if(this.FormBeneficiarios.length > 0){
              this.GuardarBeneficiariosTest(solicitudId);
            }else{
              this.confirmandoDatos = false
            }
            esBorrador ? this.AlertaEmbajadores("Progreso guardado correctamente", true) : this.AlertaEmbajadores("Solicitud guardada exitosamente.", true);
            if(this.$route.params.vieneDeAdministracion != undefined){
              if(this.esRepresentante == true)
                this.$router.push({name: "IntegracionExpedienteMoral", params: { prospectoId: this.ProspectoMoralId, vieneDeAdministracion: true }});
              else
                this.$router.push({name: "IntegracionExpediente", params: { prospectoId: this.ProspectoId, vieneDeAdministracion: true }});
            } else {
              if(this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
                if(this.esRepresentante == true) {
                  if(this.etapaProspectoMoral == 4){
                    this.$router.push({name: "IntegracionExpedienteMoral", params: { prospectoId: this.ProspectoMoralId }});
                  } else {
                    this.$router.push({name: "PreAutorizacion"});
                  }
                } else {
                  if(this.etapaProspecto == 4){
                      this.$router.push({name: "IntegracionExpediente", params: { prospectoId: this.ProspectoId }});
                  } else {
                     this.$router.push({name: "PreAutorizacion"});
                  }
                }
              } else {
                if(this.tipoUsuario == 4) {
                  this.$router.push({name: "PreAutorizacion"});
                } else {
                  if(this.esRepresentante == true){
                    this.$router.push({name: "IntegracionExpedienteMoral", params: { prospectoId: this.ProspectoMoralId }});
                  } else {
                    this.$router.push({name: "IntegracionExpediente", params: { prospectoId: this.ProspectoId }});
                  }
                }
              }
            }


          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
          this.confirmandoDatos = false
        });
    },
    ValidarMinimoCamposIngreso() {
      let camposLlenos = 0;
      Object.keys(this.DatosIngreso).forEach(llave => {
        if(llave != "ingresoId" && llave != "prospectoId")
          if(this.DatosIngreso[llave] != null && this.DatosIngreso[llave] != "" && this.DatosIngreso[llave] != 0 )
            camposLlenos++;
      });
      if(camposLlenos > 0)
        return true;
      else
        return false;
    },
    GuardarSolicitudPF(solicitudPf){
      axios.post(rutaGuardarSolicitudPf, solicitudPf)
        .then(resp => {
         if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    AjustarTiposDeDatos(){
      this.DatosSolicitudGeneral.producto = this.DatosSolicitudGeneral.producto != null ? parseInt(this.DatosSolicitudGeneral.producto) : null;
      this.DatosSolicitudGeneral.servicio = this.DatosSolicitudGeneral.servicio != null ? parseInt(this.DatosSolicitudGeneral.servicio) : null;
      this.DatosSolicitudGeneral.envioEstadoCuenta = this.DatosSolicitudGeneral.envioEstadoCuenta != null ? parseInt(this.DatosSolicitudGeneral.envioEstadoCuenta) : null;
      this.DatosSolicitudGeneral.enCasoAutorizacion = this.DatosSolicitudGeneral.enCasoAutorizacion != null ? parseInt(this.DatosSolicitudGeneral.enCasoAutorizacion) : null;
      this.DatosPersonaFisica.domicilioFiscal = this.DatosPersonaFisica.domicilioFiscal != null ? parseInt(this.DatosPersonaFisica.domicilioFiscal) : null;
      this.DatosPersonaFisica.regimenMatrimonial = this.DatosPersonaFisica.regimenMatrimonial != null ? parseInt(this.DatosPersonaFisica.regimenMatrimonial) : null;

      this.DatosPersonaFisica.lugarNacimiento = this.DatosPersonaFisica.lugarNacimiento != null ? parseInt(this.DatosPersonaFisica.lugarNacimiento) : null;
      this.DatosPersonaFisica.sexo = this.DatosPersonaFisica.sexo != null ? parseInt(this.DatosPersonaFisica.sexo) : null;
      this.DatosPersonaFisica.tipoIdentificacion = this.DatosPersonaFisica.tipoIdentificacion != null ?  parseInt(this.DatosPersonaFisica.tipoIdentificacion) : null;

      this.DatosPersonaFisica.estadoCivil = this.DatosPersonaFisica.estadoCivil != null ?  parseInt(this.DatosPersonaFisica.estadoCivil) : null;
      this.DatosPersonaFisica.nacionalidad = this.DatosPersonaFisica.nacionalidad != null ? parseInt(this.DatosPersonaFisica.nacionalidad) : null;
      this.DatosPersonaFisica.tipoEmpleo = this.DatosPersonaFisica.tipoEmpleo != null ? parseInt(this.DatosPersonaFisica.tipoEmpleo) : null;
      this.DatosPersonaFisica.tipoVivienda = this.DatosPersonaFisica.tipoVivienda != null ? parseInt(this.DatosPersonaFisica.tipoVivienda) : null;
      this.DatosPersonaFisica.gradoEstudios = this.DatosPersonaFisica.gradoEstudios != null ? parseInt(this.DatosPersonaFisica.gradoEstudios) : null;
      this.DatosPersonaFisica.profesion = this.DatosPersonaFisica.profesion != null ?  parseInt(this.DatosPersonaFisica.profesion) : null;
      this.DatosPersonaFisica.egresoMensual = this.DatosPersonaFisica.egresoMensual != null ? parseInt(this.DatosPersonaFisica.egresoMensual) : null;
      this.DatosPersonaFisica.numeroDependientes = this.DatosPersonaFisica.numeroDependientes != null ? parseInt(this.DatosPersonaFisica.numeroDependientes) : null;

      this.DatosUbicacionParticular.coloniaId = this.DatosUbicacionParticular.coloniaId != null ?  parseInt(this.DatosUbicacionParticular.coloniaId) : null;
      this.DatosUbicacionOficina.coloniaId = this.DatosUbicacionOficina.coloniaId != null ?  parseInt(this.DatosUbicacionOficina.coloniaId) : null;
      this.DatosUbicacionFiscal.coloniaId = this.DatosUbicacionFiscal.coloniaId != null ?  parseInt(this.DatosUbicacionFiscal.coloniaId) : null;


      this.PuntoContactoGeneral.telefonoFijo.valor = this.PuntoContactoGeneral.telefonoFijo.valor != null ?  this.PuntoContactoGeneral.telefonoFijo.valor.toString() : null;
      this.PuntoContactoGeneral.telefonoFijoOficina.valor = this.PuntoContactoGeneral.telefonoFijoOficina.valor != null ?  this.PuntoContactoGeneral.telefonoFijoOficina.valor.toString() : null;
      this.PuntoContactoGeneral.telefonoMovil.valor = this.PuntoContactoGeneral.telefonoMovil.valor != null ? this.PuntoContactoGeneral.telefonoMovil.valor.toString() : null;

      this.PuntoContactoConyuge.telefonoFijoConyuge.valor = this.PuntoContactoConyuge.telefonoFijoConyuge.valor != null ?  this.PuntoContactoConyuge.telefonoFijoConyuge.valor.toString() : null;
      this.PuntoContactoConyuge.correoConyuge.valor = this.PuntoContactoConyuge.correoConyuge.valor != null ?  this.PuntoContactoConyuge.correoConyuge.valor.toString() : null;
      this.PuntoContactoConyuge.telefonoMovilConyuge.valor = this.PuntoContactoConyuge.telefonoMovilConyuge.valor != null ? this.PuntoContactoConyuge.telefonoMovilConyuge.valor.toString() : null;

      this.DatosIngreso.tipoIngreso = this.DatosIngreso.tipoIngreso != null ?  parseInt(this.DatosIngreso.tipoIngreso) : null;
      this.DatosIngreso.divisa =this.DatosIngreso.divisa != null ?  parseInt(this.DatosIngreso.divisa) : null;
      if(isNaN(this.DatosIngreso.antiguedadAnios)){
        this.DatosIngreso.antiguedadAnios = null;
      } else {
        this.DatosIngreso.antiguedadAnios = this.DatosIngreso.antiguedadAnios != null ? parseInt(this.DatosIngreso.antiguedadAnios) : null;
      }
      this.DatosIngreso.antiguedadMeses = this.DatosIngreso.antiguedadMeses != null ?  parseInt(this.DatosIngreso.antiguedadMeses) : null;

    },
    async CargarDatosProspectoMoral(prospecto) {
      const prospectoparam = {
        params: {
          prospectoId: prospecto
        }
      };
      let resp = await axios.get(rutaCargarDatosProspecto, prospectoparam);
        try{
          if (resp.data.estado === 0) {
            this.etapaProspectoMoral = resp.data.data.etapaId;
          }
        }catch(e){
          this.ManejarExcepcion(e);
        }
      },
  }
}
</script>

<style lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.texto-checkbox {
  float: left;
  font-family: $poppins;
}
.etiqueta-checkbox {
  margin-left: 10px;
  text-transform: capitalize;
  font-family: $poppins;
}
.opcion-checkbox {
  float: left;
  margin-left: 20px;
  font-family: $poppins;
}

.form-group {
  margin-bottom: -15px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/**Remover iconos en los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}

/* TABLETAS */
@media all and (min-width: 768px) and (max-width: 1024px) {
}
/* CELULARES */
@media all and (max-width: 767px) {
}
</style>
